var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('br'),(!_vm.auth)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/login","tag":"button"}},[_vm._v("Вход")]):_vm._e(),(_vm.isAdmin)?_c('div',[_vm._v("Admin")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }